import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {I18NextPipe} from 'angular-i18next';
import {CountryFilterFn, CountryService, CountrySlice} from 'app/core/services/country.service';
import {CustomFormComponent} from 'app/shared/classes/custom-form-component';
import {CheckboxTreeNode, CheckboxTreePreset} from 'app/shared/components/checkbox-tree/checkbox-tree.interface';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
    selector: 'country-picker',
    templateUrl: './country-picker.component.html',
    styleUrls: ['./country-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CountryPickerComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CountryPickerComponent),
            multi: true,
        },
    ],
})
export class CountryPickerComponent extends CustomFormComponent<Set<string>> implements OnInit, OnChanges, ControlValueAccessor {
    @Input() countryFilter: CountryFilterFn;
    @Input() emptyListWarning: string;

    public countryOptions: CheckboxTreeNode[];
    public countryPresents: CheckboxTreePreset[];
    public isValid$: Observable<boolean> = new BehaviorSubject(true);
    private countrySlice: CountrySlice;

    get fullPlaceholderEnabled() {
        return this.countrySlice.holdAllAvailableCountries;
    }

    restStringFn = (count: number): string => this.i18next.transform('uiControls.enumOutput.rest', {count});

    constructor(
        $el: ElementRef,
        cd: ChangeDetectorRef,
        private i18next: I18NextPipe,
        private countries: CountryService
    ) {
        super($el, cd);
    }

    writeValue(value: Iterable<string>) {
        super.writeValue(new Set(this.countrySlice.getSafeCountriesIds(value)));
    }

    ngOnInit() {
        this.initCountriesSlice();
    }

    initCountriesSlice() {
        this.countrySlice = this.countries.getSlice(this.countryFilter);
        this.countryOptions = this.countrySlice.getSelectGroupedOptions();
        this.countryPresents = this.countrySlice.getTiersPresents();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.countryFilter && !changes.countryFilter.firstChange) {
            this.initCountriesSlice();
        }
    }

    onValueChanges(value) {
        this.internalValue = value;
        this.invokeChangeCallback(value, true);
    }

    validate(control: AbstractControl): {[p: string]: any} {
        this.isValid$ = control.statusChanges.pipe(
            startWith(control.valid),
            map(() => control.valid)
        );
        return control.errors;
    }
}
